import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../mplat/Modal';
import { ErrorModal } from '../mplat/Modals/ErrorModal';
import { SuccessModal } from '../mplat/Modals/SuccessModal';
import { AlertDescription, AlertType } from './types';

export const Alert = ({ message, title, type, onClose }: AlertDescription & { onClose: () => void }) => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(true);

    const onCloseLocal = useCallback(() => {
        onClose();
        setIsOpen(false);
    }, [onClose]);

    switch (type) {
        case AlertType.SUCCESS:
            return <SuccessModal title={title || t('Success')} content={message} isOpen={isOpen} onClose={onCloseLocal} />
        case AlertType.INFO:
            return <Modal isOpen={isOpen} onClose={onCloseLocal} maxWidth={-1}>
                <div>{title || t('Details')}</div>
                <div>
                    {message}
                </div>
            </Modal>
        case AlertType.ERROR:
        default:
            return <ErrorModal title={title || t('Error')} content={message} isOpen={isOpen} onClose={onCloseLocal} minWidth={400} />
    }
}